/* src/app/modules/institutions/institutions-edetailer/institutions-edetailer.component.scss */
/*# sourceMappingURL=institutions-edetailer.component.css.map */
